/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { CancelWithdrawalByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { CancelWithdrawalByUserUuidOkDto } from '../../src/model';
// @ts-ignore
import type { ChangePasswordForbiddenDto } from '../../src/model';
// @ts-ignore
import type { ChangePasswordInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { ChangePasswordReqBodyDto } from '../../src/model';
// @ts-ignore
import type { CreateUserAccessHistoryInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { JwtAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { JwtRefreshGuardNotFoundDto } from '../../src/model';
// @ts-ignore
import type { JwtRefreshGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { JwtTempGuardNotFoundDto } from '../../src/model';
// @ts-ignore
import type { JwtTempGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { LoginForbiddenCiDto } from '../../src/model';
// @ts-ignore
import type { LoginForbiddenDto } from '../../src/model';
// @ts-ignore
import type { LoginInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { LoginOkDto } from '../../src/model';
// @ts-ignore
import type { LoginReqBodyDto } from '../../src/model';
// @ts-ignore
import type { LoginUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { LogoutInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { RefreshInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { RefreshOkDto } from '../../src/model';
// @ts-ignore
import type { RegisterConflictDto } from '../../src/model';
// @ts-ignore
import type { RegisterCreatedDto } from '../../src/model';
// @ts-ignore
import type { RegisterInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { RegisterReqBodyDto } from '../../src/model';
// @ts-ignore
import type { RegisterUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { ResetPasswordInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { ResetPasswordReqBodyDto } from '../../src/model';
// @ts-ignore
import type { VerifyIdInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { VerifyIdOkDto } from '../../src/model';
// @ts-ignore
import type { VerifyIdReqBodyDto } from '../../src/model';
// @ts-ignore
import type { WithdrawalByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { WithdrawalByUserUuidOkDto } from '../../src/model';
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 탈퇴 취소
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCancelWithdrawalByUserUuid: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/withdrawal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 비밀번호 변경
         * @param {ChangePasswordReqBodyDto} changePasswordReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerChangePassword: async (changePasswordReqBodyDto: ChangePasswordReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordReqBodyDto' is not null or undefined
            assertParamExists('authControllerChangePassword', 'changePasswordReqBodyDto', changePasswordReqBodyDto)
            const localVarPath = `/auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 로그인
         * @param {LoginReqBodyDto} loginReqBodyDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authControllerLogin: async (loginReqBodyDto: LoginReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginReqBodyDto' is not null or undefined
            assertParamExists('authControllerLogin', 'loginReqBodyDto', loginReqBodyDto)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 로그아웃
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authControllerLogout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 토큰 갱신
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefresh: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 회원가입
         * @param {RegisterReqBodyDto} registerReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRegister: async (registerReqBodyDto: RegisterReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerReqBodyDto' is not null or undefined
            assertParamExists('authControllerRegister', 'registerReqBodyDto', registerReqBodyDto)
            const localVarPath = `/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 비밀번호 초기화(비밀번호 까먹었을 때)
         * @param {ResetPasswordReqBodyDto} resetPasswordReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResetPassword: async (resetPasswordReqBodyDto: ResetPasswordReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordReqBodyDto' is not null or undefined
            assertParamExists('authControllerResetPassword', 'resetPasswordReqBodyDto', resetPasswordReqBodyDto)
            const localVarPath = `/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tempToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 아이디 중복 확인
         * @param {VerifyIdReqBodyDto} verifyIdReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyId: async (verifyIdReqBodyDto: VerifyIdReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyIdReqBodyDto' is not null or undefined
            assertParamExists('authControllerVerifyId', 'verifyIdReqBodyDto', verifyIdReqBodyDto)
            const localVarPath = `/auth/verify-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyIdReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 탈퇴 신청
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerWithdrawalByUserUuid: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/withdrawal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 탈퇴 취소
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerCancelWithdrawalByUserUuid(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelWithdrawalByUserUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerCancelWithdrawalByUserUuid(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerCancelWithdrawalByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 비밀번호 변경
         * @param {ChangePasswordReqBodyDto} changePasswordReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerChangePassword(changePasswordReqBodyDto: ChangePasswordReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerChangePassword(changePasswordReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerChangePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 로그인
         * @param {LoginReqBodyDto} loginReqBodyDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async authControllerLogin(loginReqBodyDto: LoginReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogin(loginReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 로그아웃
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async authControllerLogout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 토큰 갱신
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRefresh(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefreshOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRefresh(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerRefresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 회원가입
         * @param {RegisterReqBodyDto} registerReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRegister(registerReqBodyDto: RegisterReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRegister(registerReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 비밀번호 초기화(비밀번호 까먹었을 때)
         * @param {ResetPasswordReqBodyDto} resetPasswordReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerResetPassword(resetPasswordReqBodyDto: ResetPasswordReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerResetPassword(resetPasswordReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerResetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 아이디 중복 확인
         * @param {VerifyIdReqBodyDto} verifyIdReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerVerifyId(verifyIdReqBodyDto: VerifyIdReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyIdOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerVerifyId(verifyIdReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerVerifyId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 탈퇴 신청
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerWithdrawalByUserUuid(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WithdrawalByUserUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerWithdrawalByUserUuid(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerWithdrawalByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary 탈퇴 취소
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCancelWithdrawalByUserUuid(options?: RawAxiosRequestConfig): AxiosPromise<CancelWithdrawalByUserUuidOkDto> {
            return localVarFp.authControllerCancelWithdrawalByUserUuid(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 비밀번호 변경
         * @param {AuthApiAuthControllerChangePasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerChangePassword(requestParameters: AuthApiAuthControllerChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authControllerChangePassword(requestParameters.changePasswordReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 로그인
         * @param {AuthApiAuthControllerLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authControllerLogin(requestParameters: AuthApiAuthControllerLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginOkDto> {
            return localVarFp.authControllerLogin(requestParameters.loginReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 로그아웃
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authControllerLogout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authControllerLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 토큰 갱신
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefresh(options?: RawAxiosRequestConfig): AxiosPromise<RefreshOkDto> {
            return localVarFp.authControllerRefresh(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 회원가입
         * @param {AuthApiAuthControllerRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRegister(requestParameters: AuthApiAuthControllerRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterCreatedDto> {
            return localVarFp.authControllerRegister(requestParameters.registerReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 비밀번호 초기화(비밀번호 까먹었을 때)
         * @param {AuthApiAuthControllerResetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResetPassword(requestParameters: AuthApiAuthControllerResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authControllerResetPassword(requestParameters.resetPasswordReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 아이디 중복 확인
         * @param {AuthApiAuthControllerVerifyIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyId(requestParameters: AuthApiAuthControllerVerifyIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyIdOkDto> {
            return localVarFp.authControllerVerifyId(requestParameters.verifyIdReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 탈퇴 신청
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerWithdrawalByUserUuid(options?: RawAxiosRequestConfig): AxiosPromise<WithdrawalByUserUuidOkDto> {
            return localVarFp.authControllerWithdrawalByUserUuid(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for authControllerChangePassword operation in AuthApi.
 * @export
 * @interface AuthApiAuthControllerChangePasswordRequest
 */
export interface AuthApiAuthControllerChangePasswordRequest {
    /**
     * 
     * @type {ChangePasswordReqBodyDto}
     * @memberof AuthApiAuthControllerChangePassword
     */
    readonly changePasswordReqBodyDto: ChangePasswordReqBodyDto
}

/**
 * Request parameters for authControllerLogin operation in AuthApi.
 * @export
 * @interface AuthApiAuthControllerLoginRequest
 */
export interface AuthApiAuthControllerLoginRequest {
    /**
     * 
     * @type {LoginReqBodyDto}
     * @memberof AuthApiAuthControllerLogin
     */
    readonly loginReqBodyDto: LoginReqBodyDto
}

/**
 * Request parameters for authControllerRegister operation in AuthApi.
 * @export
 * @interface AuthApiAuthControllerRegisterRequest
 */
export interface AuthApiAuthControllerRegisterRequest {
    /**
     * 
     * @type {RegisterReqBodyDto}
     * @memberof AuthApiAuthControllerRegister
     */
    readonly registerReqBodyDto: RegisterReqBodyDto
}

/**
 * Request parameters for authControllerResetPassword operation in AuthApi.
 * @export
 * @interface AuthApiAuthControllerResetPasswordRequest
 */
export interface AuthApiAuthControllerResetPasswordRequest {
    /**
     * 
     * @type {ResetPasswordReqBodyDto}
     * @memberof AuthApiAuthControllerResetPassword
     */
    readonly resetPasswordReqBodyDto: ResetPasswordReqBodyDto
}

/**
 * Request parameters for authControllerVerifyId operation in AuthApi.
 * @export
 * @interface AuthApiAuthControllerVerifyIdRequest
 */
export interface AuthApiAuthControllerVerifyIdRequest {
    /**
     * 
     * @type {VerifyIdReqBodyDto}
     * @memberof AuthApiAuthControllerVerifyId
     */
    readonly verifyIdReqBodyDto: VerifyIdReqBodyDto
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary 탈퇴 취소
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerCancelWithdrawalByUserUuid(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerCancelWithdrawalByUserUuid(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 비밀번호 변경
     * @param {AuthApiAuthControllerChangePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerChangePassword(requestParameters: AuthApiAuthControllerChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerChangePassword(requestParameters.changePasswordReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 로그인
     * @param {AuthApiAuthControllerLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerLogin(requestParameters: AuthApiAuthControllerLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLogin(requestParameters.loginReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 로그아웃
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerLogout(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 토큰 갱신
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerRefresh(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerRefresh(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 회원가입
     * @param {AuthApiAuthControllerRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerRegister(requestParameters: AuthApiAuthControllerRegisterRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerRegister(requestParameters.registerReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 비밀번호 초기화(비밀번호 까먹었을 때)
     * @param {AuthApiAuthControllerResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerResetPassword(requestParameters: AuthApiAuthControllerResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerResetPassword(requestParameters.resetPasswordReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 아이디 중복 확인
     * @param {AuthApiAuthControllerVerifyIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerVerifyId(requestParameters: AuthApiAuthControllerVerifyIdRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerVerifyId(requestParameters.verifyIdReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 탈퇴 신청
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerWithdrawalByUserUuid(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerWithdrawalByUserUuid(options).then((request) => request(this.axios, this.basePath));
    }
}

